import React from "react";

export const filterMapper = (
  props: React.DetailedHTMLProps<React.HTMLAttributes<Element>, HTMLElement>
) => {
  return <p>{props.children}</p>;
};
